var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.products.length > 0
    ? _c(
        "rb-smart-container",
        {
          attrs: {
            "slides-per-view-desktop": _vm.slidesPerViewDesktop,
            "slides-per-view-tablet": 3,
            "slides-per-view-mobile": _vm.slidesPerViewMobile,
            "columns-of-next-slide": _vm.columnsOfNextSlide,
            "always-show-swiper": true,
            pagination: _vm.hasPagination,
          },
        },
        _vm._l(_vm.products, function (product, index) {
          return _c("rb-product-tile", {
            key: index,
            attrs: {
              "element-id": "" + _vm.dataElementId + index,
              product: product,
              "wishlist-icon-is-visible": _vm.wishlistIconIsVisible,
            },
          })
        }),
        1
      )
    : _c(
        "div",
        { staticClass: "skeleton block-skeleton banners" },
        _vm._l(3, function (index) {
          return _c("div", { key: index, staticClass: "dummy-block" }, [
            _c("div", { staticClass: "skeleton skeleton-copy-container" }),
          ])
        }),
        0
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }